import { createApp } from 'vue';

export default {
    name : 'hero',
    init() {
        const elm = document.querySelector('.hero');

        if(!(elm)){
            return;
        }
        this.run(elm);
    },

    run (elm)
    {
        createApp({

            data() {
                return {
                  layerToggled : false,
                  embedEl: null,
                  embedHtml: null,
                }
            },

            computed :
            {
                layerToggledClass() {
                    return (this.layerToggled) ? ' active ' : '';
                },
            },

            methods:
            {
                toggleLayer(event) {
                    this.layerToggled = (this.layerToggled) ? false : true;
                    this.embedEl = elm.querySelector("[data-embed]");

                    if(this.embedEl){
                        this.injectVimeo();
                    }

                },

                injectVimeo(){
                    let iframe = '<iframe src="'+this.embedEl.dataset.embed+'" class="video__iframe border-radius" title="vimeo video" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture"></iframe>';
                    this.embedHtml = iframe;
                }
            },
            created ()
            {
                // _log('hero ready');
            }
        }).mount(elm);
    }
}